import { ArrowLeft, ArrowRight } from "lucide-react";
import StickyFooterCTA from "../ui/StickyFooterCTA";

// Iter AO — SOAP fields remain editable for compliance, but the standalone
// "Draft with AI" CTA was removed. The Recommendations bundle's
// `clinical_summary` (auto-generated from the single verbal debrief) already
// covers the AI-drafting role, so we no longer ask the therapist to describe
// the session a second time here.

const SOAP_FIELDS = [
  { key: "subjective", label: "S \u2014 Subjective", help: "What the client reports (pain, history, complaint)" },
  { key: "objective",  label: "O \u2014 Objective",  help: "Your observations and measurable findings" },
  { key: "assessment", label: "A \u2014 Assessment", help: "Your clinical interpretation" },
  { key: "plan",       label: "P \u2014 Plan",       help: "Treatment plan & follow-up" },
];

export default function SoapSection({ soap, setSoap, setPhase }) {
  return (
    <div data-testid="soap-phase">
      <div className="label-overline mb-2">SOAP notes (manual edit)</div>
      <h2 className="font-heading text-2xl sm:text-3xl font-light tracking-tight text-ink-900 mb-2">Document the session</h2>
      <p className="text-ink-700 mb-6 max-w-2xl text-sm">
        These are auto-aligned with the AI Clinical Summary above. Edit any field for compliance or to add detail the AI missed.
      </p>

      <div className="bg-white border border-paper-200 rounded-3xl p-6 sm:p-8 mb-10 divide-y divide-paper-200">
        {SOAP_FIELDS.map((f) => (
          <div key={f.key} className="py-5 first:pt-0 last:pb-0">
            <div className="flex items-center justify-between mb-2">
              <div className="label-overline">{f.label}</div>
              <div className="text-xs text-ink-500">{f.help}</div>
            </div>
            <textarea
              data-testid={`soap-${f.key}`}
              value={soap[f.key]}
              onChange={(e) => setSoap({ ...soap, [f.key]: e.target.value })}
              rows={5}
              className="w-full px-4 py-3 rounded-xl bg-paper-50 border border-paper-200 focus:ring-2 focus:ring-sage-500/30 focus:border-sage-500 outline-none resize-y min-h-[140px]"
            />
          </div>
        ))}
      </div>

      {setPhase && (
        <StickyFooterCTA testid="soap-footer" className="justify-between">
          <button onClick={() => setPhase("diagram")} className="min-h-[48px] px-5 rounded-full text-ink-700 hover:bg-paper-100 inline-flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Back
          </button>
          <button onClick={() => setPhase("outcome")} className="min-h-[48px] px-6 rounded-full bg-sage-500 hover:bg-sage-600 text-white font-medium inline-flex items-center gap-2" data-testid="to-outcome-btn">
            Track outcome <ArrowRight className="w-4 h-4" />
          </button>
        </StickyFooterCTA>
      )}
    </div>
  );
}
